<template>
	<div class="default-carousel swiper" ref="carousel">
		<div class="default-carousel__navigation">
			<div class="swiper-pagination"></div>
			<div class="swiper-button-container">
				<div
					:id="'button-prev-' + uniqueElementId"
					class="swiper-button swiper-button-prev"
				>
					<svg
						width="32"
						height="32"
						viewBox="0 0 32 32"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M16.6995 27.1339C16.2113 26.6457 16.2113 25.8543 16.6995 25.3661L25.8156 16.25L16.6995 7.13388C16.2113 6.64573 16.2113 5.85427 16.6995 5.36612C17.1876 4.87796 17.9791 4.87796 18.4673 5.36612L28.4673 15.3661C28.9554 15.8543 28.9554 16.6457 28.4673 17.1339L18.4673 27.1339C17.9791 27.622 17.1876 27.622 16.6995 27.1339Z"
							fill="#191A1A"
						/>
						<path
							d="M27 16.1667L4.33337 16.1667"
							stroke="#191A1A"
							stroke-width="2"
							stroke-linecap="round"
						/>
					</svg>
				</div>
				<div
					:id="'button-next-' + uniqueElementId"
					class="swiper-button swiper-button-next"
				>
					<svg
						width="32"
						height="32"
						viewBox="0 0 32 32"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M16.6995 27.1339C16.2113 26.6457 16.2113 25.8543 16.6995 25.3661L25.8156 16.25L16.6995 7.13388C16.2113 6.64573 16.2113 5.85427 16.6995 5.36612C17.1876 4.87796 17.9791 4.87796 18.4673 5.36612L28.4673 15.3661C28.9554 15.8543 28.9554 16.6457 28.4673 17.1339L18.4673 27.1339C17.9791 27.622 17.1876 27.622 16.6995 27.1339Z"
							fill="#191A1A"
						/>
						<path
							d="M27 16.1667L4.33337 16.1667"
							stroke="#191A1A"
							stroke-width="2"
							stroke-linecap="round"
						/>
					</svg>
				</div>
			</div>
		</div>
		<div class="swiper-wrapper">
			<slot />
		</div>
	</div>
</template>

<script setup>
import { useTemplateRef, onMounted } from "vue";
import Swiper from "swiper";
import {
	A11y,
	Mousewheel,
	Navigation,
	Pagination,
	Scrollbar,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/a11y";

const uniqueElementId = useId();
const carousel = useTemplateRef("carousel");
const swiperOptions = {
	modules: [A11y, Mousewheel, Navigation, Pagination, Scrollbar],
	slidesPerView: 1.2,
	spaceBetween: 0,
	simulateTouch: false,
	mousewheel: {
		forceToAxis: true,
	},
	a11y: {
		enabled: true,
		prevSlideMessage: "Previous Slide",
		nextSlideMessage: "Next Slide",
	},
	navigation: {
		nextEl: `#button-next-${uniqueElementId}`,
		prevEl: `#button-prev-${uniqueElementId}`,
	},
	pagination: {
		el: ".swiper-pagination",
	},

	/*
	scrollbar: {
		watchOverflow: true,
		draggable: true,
		type: 'custom',
		dragSize: 'auto',
		el: `#scrollbar-${uniqueElementId}`,
	},
*/
};

onMounted(() => {
	if (carousel.value) new Swiper(carousel.value, swiperOptions);
});
</script>
